import * as t from 'io-ts'

const PaginatedResponseIO = <C extends t.Mixed>(codec: C) =>
  t.type({
      content: codec,
      currentPage:t.number,
      totalNumberOfPages: t.number,
      totalRecords: t.number,
  })

export default PaginatedResponseIO
